import React from 'react';
import styles from './MostUsedKnowledgeBase.module.scss';
import Tooltip from 'component/Custom/tooltip/Tooltip';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { useFetch } from 'hooks/useFetch';
import { dashboardEndpoints } from 'hooks/endpoints';
import NoData from 'component/Custom/NoData/NoData';

const MostUsedKnowledgeBase = ({ id, startDate, endDate }) => {
  const { data, refetch } = useFetch(
    ['Most-Used-KnowledgeBase', startDate, endDate, id],
    dashboardEndpoints.getKnowledgeBase(startDate, endDate, id),
    { enabled: true },
    id ? { botId: id } : {}
  );

  const handleDownload = () => {
    const doc = new jsPDF('landscape');
    const title = 'Most-Used Knowledge Base';
    doc.setFontSize(16);
    doc.text(title, 14, 16);

    autoTable(doc, {
      head: [['KB Item', 'Type', 'Usage Count']],
      body: data.data.map((r) => [r.item, r.type, String(r.count)]),
      startY: 24,
      styles: {
        fontSize: 11,
        cellPadding: 6,
        halign: 'left',
        valign: 'middle',
      },
      headStyles: { fillColor: [7, 68, 225], textColor: 255 },
      columnStyles: {
        0: { cellWidth: 180 },
        1: { cellWidth: 60 },
        2: { cellWidth: 60, halign: 'right' },
      },
      didDrawPage: (data) => {
        const pageSize = doc.internal.pageSize;
        const pageWidth = pageSize.getWidth();
        doc.setFontSize(9);
        doc.text(`${new Date().toLocaleDateString()}`, pageWidth - 14, 10, {
          align: 'right',
        });
      },
    });

    doc.save('most_used_knowledge_base.pdf');
  };

  return (
    <div className={styles['card']}>
      <div className={styles['actions-container']}>
        <div className={styles['title-container']}>
          <span className={styles['title']}>Most-Used Knowledge Base</span>
          <Tooltip
            content='Shows the most frequently accessed knowledge
base files or URLs within the selected timeframe.'
            className={styles['tooltip']}
          >
            <SvgWithBranding type='info' color='#0744E1' width={22} />
          </Tooltip>
        </div>
        <SvgWithBranding
          className={styles['download-icon']}
          type='download2'
          onClick={handleDownload}
        />
      </div>

      <div className={styles['table-wrap']}>
        <div className={styles['table-header']}>
          <div className={styles['th-item']}>KB Item</div>
          <div className={styles['th-type']}>Type</div>
          <div className={styles['th-count']}>Usage Count</div>
        </div>

        <div className={styles['table-body']}>
          {data?.data.length > 0 ? (
            data?.data?.slice(0, 5).map((r, idx) => (
              <div key={idx} className={styles['tr']}>
                <div className={styles['td-item']}>{r.caption}</div>
                <div className={styles['td-type']}>{r.contentType}</div>
                <div className={styles['td-count']}>{r.score}</div>
              </div>
            ))
          ) : (
            <NoData />
          )}
        </div>
      </div>
    </div>
  );
};

export default MostUsedKnowledgeBase;
